import { ONBOARDING_LINK_COLOR, ONBOARDING_TEXT_COLOR } from './DocumentProcessingPage.constants';

export const onboardingRow = () => ({
    backgroundColor: '#faf6ff',
    '& td': {
        color: ONBOARDING_TEXT_COLOR,
    },
    '& td button': {
        color: ONBOARDING_LINK_COLOR,
    },
});

export const moreButton = () => ({
    border: 'none',
    boxShadow: 'none',
    background: 'transparent',

    ':hover': {
        background: 'transparent',
    }
});
